// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum DryingForecast {
    Poor = 0,
    Moderate = 1,
    Excellent = 2,
}
export default DryingForecast;
